module.exports = "https://cdn.dove.it/_next/static/public/assets/services/virtual-tour_340x200.59e8ce0f2237d273d9fa83a73ecd260e.jpg";